import React, { useEffect } from "react"
import { RouteComponentProps } from "react-router"
import { Loading } from "../../components/parts/loading"
import { JSONRPCErrorCatch } from "../../error/error"
import { JSONRPCClientBuilder } from "../../request/JSONRPCClientBuilder"
import { EpisodeRPC } from "../../rpcs/dist/EpisodeRPC"
import { UserRPC } from "../../rpcs/dist/UserRPC"
import { container, IContainerProps } from "./container"
import { EditorMain } from "./editor-main"

type IProps = IContainerProps &
  RouteComponentProps<{
    name: string
    displayId: string
  }>

const fetchEpisode = async (displayId: string) => {
  const rpc = JSONRPCClientBuilder.build(EpisodeRPC)
  return rpc.fetchEpisodeDetail({ displayId }, { cacheUsable: false })
}

const fetchUserBelongsChannel = async () => {
  const rpc = JSONRPCClientBuilder.build(UserRPC)
  return rpc.listChannels()
}

const EditorComponent = (props: IProps) => {
  const isLoading = () => {
    return !(props.episode && props.channels && props.currentUser)
  }

  useEffect(() => {
    ;(async () => {
      try {
        const [episode, channels] = await Promise.all([
          fetchEpisode(props.match.params.displayId),
          fetchUserBelongsChannel(),
        ])
        props.actions.fetchEpisodeData(episode)
        props.actions.fetchChannelData(channels)
      } catch (e) {
        JSONRPCErrorCatch(e)
      }
    })()
    return props.actions.leaveThePage()
    // eslint-disable-next-line
  }, [props.match.params.displayId])

  if (isLoading()) {
    return <Loading />
  }

  return <EditorMain />
}

export default container(EditorComponent)
